import React, { useContext } from "react";
import SubHeader from "../../components/subheader/SubHeader";
import "./Budget.scss";
import FunnelChart from "../../../src/components/budget/funnelchart/FunnelChart";
import BudgetLineChart from "../../components/budget/budgetlinechart/BudgetLineChart";
import ClusteredColumnsChart from "../../components/budget/clusteredcolumnschart/ClusteredColumnsChart";
import BudgetTotalYearCard from "../../components/budget/budgettotalyearcard/BudgetTotalYearCard";
import BudgetTotalQuarterCard from "../../components/budget/budgettotalquartercard/BudgetTotalQuarterCard";
import BudgetTotalMonthCard from "../../components/budget/budgettotalmonthcard/BudgetTotalMonthCard";
import { AppContext } from "../../context/Context";
import BudgetTable from "../../components/budget/budgettable/BudgetTable";
import BudgetTable2 from "../../components/budget/budgettable/BudgetTable2";
import { getQuarterByMonth, createRevenueDateTitle, createRevenueCardYearTitle, createRevenueCardQuarterTitle, createRevenueCardMonthTitle } from "../../utils/format";

const Budget = () => {
  const { data, fromDate, toDate } = useContext(AppContext);

  const allData = data.budget?.budgetmonths || [];

  const firstRevenueYearMonth =
    allData.length > 0 ? allData[0].year_month : null;

  const lastRevenueYearMonth =
    allData.length > 0 ? allData[allData.length - 1].year_month : null;

  const computeTotalBudgetYear= (fromDate, toDate, data) => {
    let total = 0;

    if (fromDate === "All" || !toDate) {
      total =
         data?.budget?.budgetmonths
        //  ?.filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
         .reduce(
          (sum, item) => sum + (item.Value || 0),
          0
        ) || 0;
    } else {
      const fromYear = parseInt(fromDate.split("-")[0]);
      const toYear = parseInt(toDate.split("-")[0]);

      total =
         data?.budget?.budgetmonths
          ?.filter((item) => {
            const itemYear = parseInt(item.year_month.split("-")[0]);
            return itemYear >= fromYear && itemYear <= toYear;
          })
          .reduce((sum, item) => sum + (item.Value || 0), 0) || 0;
    }

    // Format with commas and 2 decimal places
    return total;
  };

  const computeTotalBudgetYearByAgentCommission = (fromDate, toDate, data) => {
    let total = 0;

    if (fromDate === "All" || !toDate) {
      total =
        data.budget?.budgetcogs
        // ?.filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
        .reduce(
          (sum, item) => sum + (item.Value || 0),
          0
        ) || 0;
    } else {
      const fromYear = parseInt(fromDate.split("-")[0]);
      const toYear = parseInt(toDate.split("-")[0]);

      total =
        data.budget?.budgetcogs
          ?.filter((item) => {
            const itemYear = parseInt(item.year_month.split("-")[0]);
            return itemYear >= fromYear && itemYear <= toYear;
          })
          .reduce((sum, item) => sum + (item.Value || 0), 0) || 0;
    }

    // Format with commas and 2 decimal places
    return total;
  };

  const computeTotalBudgetYearByExpensesBudget= (fromDate, toDate, data) => {
    let total = 0;

    if (fromDate === "All" || !toDate) {
      total =
        data.budget?.budgetexpensesmonth
        // ?.filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
        .reduce(
          (sum, item) => sum + (item.Value || 0),
          0
        ) || 0;
    } else {
      const fromYear = parseInt(fromDate.split("-")[0]);
      const toYear = parseInt(toDate.split("-")[0]);

      total =
        data.budget?.budgetexpensesmonth
          ?.filter((item) => {
            const itemYear = parseInt(item.year_month.split("-")[0]);
            return itemYear >= fromYear && itemYear <= toYear;
          })
          .reduce((sum, item) => sum + (item.Value || 0), 0) || 0;
    }

    // Format with commas and 2 decimal places
    return total;
  };

  const computeTotalBudgetsQuarter = (fromDate, toDate, data) => {
    if (!data.budget?.budgetmonths) return 0;

    // Handle "All"
    if (fromDate === "All" || !toDate) {
      return data.budget?.budgetmonths
      // ?.filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
      .reduce(
        (sum, item) => sum + (item.Value || 0),
        0
      );
    }

    // --- Parse from/to year & month ---
    const [fromYear, fromMonth] = fromDate.split("-").map(Number);
    const [toYear, toMonth] = toDate.split("-").map(Number);

    const fromQuarter = getQuarterByMonth(fromMonth);
    const toQuarter = getQuarterByMonth(toMonth);

    // --- Filter ---
    const total = data.budget?.budgetmonths
      .filter((item) => {
        const [itemYear, itemMonth] = item.year_month.split("-").map(Number);
        const itemQuarter = getQuarterByMonth(itemMonth);

        // year before range
        if (itemYear < fromYear || itemYear > toYear) return false;

        // same year as start
        if (itemYear === fromYear && itemQuarter < fromQuarter) return false;

        // same year as end
        if (itemYear === toYear && itemQuarter > toQuarter) return false;

        // in between years → always included
        return true;
      })
      .reduce((sum, item) => sum + (item.Value || 0), 0);

    return total;
  };

  const computeTotalBudgetQuarterByAgentCommission = (fromDate, toDate, data) => {
    if (!data.budget?.budgetcogs) return 0;

    // Handle "All"
    if (fromDate === "All" || !toDate) {
      return data.budget?.budgetcogs
      // ?.filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
      .reduce(
        (sum, item) => sum + (item.Value || 0),
        0
      );
    }

    // --- Parse from/to year & month ---
    const [fromYear, fromMonth] = fromDate.split("-").map(Number);
    const [toYear, toMonth] = toDate.split("-").map(Number);

    const fromQuarter = getQuarterByMonth(fromMonth);
    const toQuarter = getQuarterByMonth(toMonth);

    // --- Filter ---
    const total = data.budget?.budgetcogs
      .filter((item) => {
        const [itemYear, itemMonth] = item.year_month.split("-").map(Number);
        const itemQuarter = getQuarterByMonth(itemMonth);

        // year before range
        if (itemYear < fromYear || itemYear > toYear) return false;

        // same year as start
        if (itemYear === fromYear && itemQuarter < fromQuarter) return false;

        // same year as end
        if (itemYear === toYear && itemQuarter > toQuarter) return false;

        // in between years → always included
        return true;
      })
      .reduce((sum, item) => sum + (item.Value || 0), 0);

    return total;
  };

  const computeTotalBudgetQuarterByExpensesBudget = (fromDate, toDate, data) => {
    if (!data.budget?.budgetexpensesmonth) return 0;

    // Handle "All"
    if (fromDate === "All" || !toDate) {
      return data.budget?.budgetexpensesmonth
      // ?.filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
      .reduce(
        (sum, item) => sum + (item.Value || 0),
        0
      );
    }

    // --- Parse from/to year & month ---
    const [fromYear, fromMonth] = fromDate.split("-").map(Number);
    const [toYear, toMonth] = toDate.split("-").map(Number);

    const fromQuarter = getQuarterByMonth(fromMonth);
    const toQuarter = getQuarterByMonth(toMonth);

    // --- Filter ---
    const total = data.budget?.budgetexpensesmonth
      .filter((item) => {
        const [itemYear, itemMonth] = item.year_month.split("-").map(Number);
        const itemQuarter = getQuarterByMonth(itemMonth);

        // year before range
        if (itemYear < fromYear || itemYear > toYear) return false;

        // same year as start
        if (itemYear === fromYear && itemQuarter < fromQuarter) return false;

        // same year as end
        if (itemYear === toYear && itemQuarter > toQuarter) return false;

        // in between years → always included
        return true;
      })
      .reduce((sum, item) => sum + (item.Value || 0), 0);

    return total;
  }

  const computeTotalBudgetCurrentMonth = (data) => {
    const lines = data.budget?.budgetmonthfilter;
    if (!Array.isArray(lines)) return "0.00";

    const total = lines
    .filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
    .reduce(
      (sum, item) => sum + (item.Value || 0),
      0
    );
    return total;
  };

  const computeTotalBudgetPreviousMonth = (data) => {
    if (!data.budget?.budgetpreviousmonth) return 0;
    return data.budget?.budgetpreviousmonth.reduce(
      (sum, item) => sum + item.Value,
      0
    );
  }

  const computeTotalBudgetCurrentMonthByAgentCommission = (data) => {
    const lines = data.budget?.budgetcogsfilter;
    if (!Array.isArray(lines)) return "0.00";

    const total = lines
    .filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
    .reduce(
      (sum, item) => sum + (item.Value || 0),
      0
    );    

    return total;
  };

  const computeTotalBudgetCurrentMonthByExpensesBudget = (data) => {
    const lines = data.budget?.budgetexpensesfilter;
    if (!Array.isArray(lines)) return "0.00";

    const total = lines
    .filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
    .filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate).reduce(
      (sum, item) => sum + (item.Value || 0),
      0
    );    

    return total;
  };

  const shortcutimport = data?.budget || [];

  const merged =
    shortcutimport?.budgetmonths && Array.isArray(shortcutimport.budgetmonths)
      ? shortcutimport.budgetmonths
          .map((item, index) => {
            const actualValue =
              shortcutimport.budgetactualexpenses?.[index]?.actual_cogs_expense;

            if (typeof actualValue === "number" && actualValue !== 0) {
              return {
                month: item.year_month,
                budget: item.Value,
                actual: actualValue,
              };
            }

            return null;
          })
          .filter(Boolean) // Loại bỏ null khỏi mảng
      : [];

  const mergedLineChart =
    shortcutimport?.budgetcogs && Array.isArray(shortcutimport?.budgetcogs)
      ? shortcutimport?.budgetcogs
          .map((item, index) => {
            const actualValue =
              data.cost?.commisson.overall.costoverallmonthscolumns?.[index]
                ?.goods_sold_cost;

            if (typeof actualValue === "number" && actualValue !== 0) {
              return {
                month: item.year_month,
                budget: item.Value,
                actual: actualValue,
              };
            }

            return null;
          })
          .filter(Boolean)
      : [];

  const mergedLineChartBudgetExpenses =
    shortcutimport?.budgetexpensesmonth &&
    Array.isArray(shortcutimport.budgetexpensesmonth)
      ? shortcutimport.budgetexpensesmonth
          .map((item, index) => {
            const actualValue = data.expenses.expensesmonth?.[index]?.expenses;

            if (typeof actualValue === "number" && actualValue !== 0) {
              return {
                month: item.year_month,
                budget: item.Value,
                actual: actualValue,
              };
            }

            return null; // bỏ dòng không hợp lệ
          })
          .filter(Boolean)
      : [];

  const totalSumCogsMonth = data.budget?.budgetactual
    .map((item) => item.spent)
    .reduce((acc, curr) => acc + curr, 0);
  
  const totalCOGSBudget = computeTotalBudgetYearByAgentCommission("All", "", data)
  const budgetData = {
    totalBudget: totalCOGSBudget,
    spent: totalSumCogsMonth,
    leftToSpend: totalCOGSBudget - totalSumCogsMonth,
  };

  const totalSumBudgetFilter = data.budget?.budgetcostfilterfunnel
    // .filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
    .map((item) => item.Value)
    .reduce((acc, curr) => acc + curr, 0);

  const totalSumCogsMonthFilter =
    data.cost?.commisson.overall.constoverallmonthsfunnel
      .map((item) => item.goods_sold_cost)
      .reduce((acc, curr) => acc + curr, 0);

  const budgetDataFilter = {
    totalBudget: totalSumBudgetFilter,
    spent: totalSumCogsMonthFilter,
    leftToSpend: totalSumBudgetFilter - totalSumCogsMonthFilter,
  };

  // const totalSumCogsMonthExpense = data.budget?.budgetexpensetactual
  //   .map((item) => item.spent)
  //   .reduce((acc, curr) => acc + curr, 0);

  const totalSumCogsMonthExpenseFilter =
    data.expenses?.expensesmonthfiltersfunnel
      .map((item) => item.expenses)
      .reduce((acc, curr) => acc + curr, 0);

  const totalExpensesBudget = computeTotalBudgetYearByExpensesBudget("All", "", data)
  const budgetDataexpenses = {
    totalBudget: totalExpensesBudget,
    spent: totalSumCogsMonthExpenseFilter,
    leftToSpend: totalExpensesBudget - totalSumCogsMonthExpenseFilter,
  };

  const totalSumBudgetExpenseFilter =
    data.budget?.budgetexpenseactualfilterfunnel
      // .filter(item => data.firstdate <= item.year_month && item.year_month <= data.lastdate)
      .map((item) => item.Value)
      .reduce((acc, curr) => acc + curr, 0);

  

  // const totalSumLeftToSpentExpenseFilter =
  //   data.budget?.budgetlefttospentcogsfiltersexpense
  //     .map((item) => item.left_to_spend)
  //     .reduce((acc, curr) => acc + curr, 0);

  const budgetDataexpensesFilter = {
    totalBudget: totalSumBudgetExpenseFilter,
    spent: totalSumCogsMonthExpenseFilter,
    leftToSpend: totalSumBudgetExpenseFilter - totalSumCogsMonthExpenseFilter,
    // leftToSpend: totalSumLeftToSpentExpenseFilter,
  };

  // Filter data within the given date range
  const budgetActualYear = shortcutimport.budgetactualfilter
  // const budgetActualYear = shortcutimport.budgetactualfilter.filter(item => 
  //   item.year_month >= data.firstdate && item.year_month <= data.lastdate
  // );

  // Handle "All" or specific range for month filtering
  // const budgetActualMonth = shortcutimport.budgetactualfilter.filter(item => item.year_month >= fromDate && item.year_month <= toDate);
  const budgetActualMonth = shortcutimport.budgetactualfilter.filter(item => {
    if (fromDate === "All") return true;
    return item.year_month >= fromDate && item.year_month <= toDate;
  });

  const budgetExpensesActualYear = shortcutimport.budgetexpenseactualfilter

  // const budgetExpensesActualYear = shortcutimport.budgetexpenseactualfilter.filter(item =>
  //   item.year_month >= data.firstdate && item.year_month <= data.lastdate
  // );

  // Handle "All" or specific range for month filtering
  const budgetExpensesActualMonth = shortcutimport.budgetexpenseactualfilter.filter(item => {
    if (fromDate === "All") return true;
    return item.year_month >= fromDate && item.year_month <= toDate;
  });

  return (
    <div className="main-frame-budget">
      <SubHeader title="BUDGET" />

      <div className="frame-budget-block1">
        <div className="frame-budget-block1-left">
          <BudgetTotalYearCard
            title={createRevenueCardYearTitle(firstRevenueYearMonth, lastRevenueYearMonth, fromDate, toDate)}
            totalBudget={computeTotalBudgetYear(fromDate, toDate, data)}
            agentCommissionBudget={computeTotalBudgetYearByAgentCommission(fromDate, toDate, data)}
            expensesBudget={computeTotalBudgetYearByExpensesBudget(fromDate, toDate, data)}
          />
        </div>
         <div className="frame-budget-block1-left">
          <BudgetTotalQuarterCard
            title={createRevenueCardQuarterTitle(firstRevenueYearMonth, lastRevenueYearMonth, fromDate, toDate)}
            totalBudget={computeTotalBudgetsQuarter(fromDate, toDate, data)}
            agentCommissionBudget={computeTotalBudgetQuarterByAgentCommission(fromDate, toDate, data)}
            expensesBudget={computeTotalBudgetQuarterByExpensesBudget(fromDate, toDate, data)}
          />
        </div>
        <div className="frame-budget-block1-right">
          <BudgetTotalMonthCard 
            title={createRevenueCardMonthTitle(data.firstdate, data.lastdate, fromDate, toDate)}
            totalBudget={computeTotalBudgetCurrentMonth(data)}
            previousTotalBudget={computeTotalBudgetPreviousMonth(data)}
            agentCommissionBudget={computeTotalBudgetCurrentMonthByAgentCommission(data)}
            expensesBudget={computeTotalBudgetCurrentMonthByExpensesBudget(data)}
          />
        </div>
      </div>

      <div className="frame-budget-block2">
        <h3>TOTAL BUDGET AND ACTUAL COGS & EXPENSES BY MONTHS</h3>
        <div className="frame-column-budget-chart">
          <ClusteredColumnsChart data={merged} />
        </div>
      </div>
      <div className="frame-budget-block3">
        <div className="frame-budget-block3-left">
          <h3>TOTAL BUDGET (COGS) AND TOTAL ACTUAL COGS BY MONTHS</h3>
          <BudgetLineChart
            data={mergedLineChart}
            nameline1="Total Budget (COGS)"
            nameline2="Total COGS"
          />
        </div>
        <div className="frame-budget-block3-right">
          <h3>TOTAL BUDGET (EXPENSES) AND TOTAL ACTUAL EXPENSES BY MONTHS</h3>
          <BudgetLineChart
            data={mergedLineChartBudgetExpenses}
            nameline1="Total Budget (Expenses)"
            nameline2="Total Expenses"
          />
        </div>
      </div>

      <div className="frame-block-time-range-data">
        <div className="frame-all-time-data">
          <h1>2024 - 2025</h1>
        </div>

        <div className="frame-filter-data">
          <h1>
            {createRevenueDateTitle(data.firstdate, data.lastdate, fromDate, toDate)}
            {/* {formatYearMonth(
              dataRange === "All" ? lastMonth?.year_month : dataRange
            )} */}
          </h1>
        </div>
      </div>

      <div className="frame-budget-block4">
        <div className="frame-budget-block4-left">
          <h3>COST OF GOOD SOLD BUDGET</h3>
          <FunnelChart budgetData={budgetData} />
        </div>
        <div className="frame-budget-block4-right">
          <h3>COST OF GOOD SOLD BUDGET</h3>
          <FunnelChart budgetData={budgetDataFilter} />
        </div>
      </div>

      <div className="frame-budget-block5">
        <div className="frame-budget-block5-left">
          <h3>EXPENSES BUDGET</h3>
          <FunnelChart budgetData={budgetDataexpenses} />
        </div>
        <div className="frame-budget-block5-right">
          <h3>EXPENSES BUDGET</h3>
          <FunnelChart budgetData={budgetDataexpensesFilter} />
        </div>
      </div>

      <div className="frame-budget-block6">
        <div className="frame-budget-block6-left">
          <h3>COST OF GOODS SOLD VS ACTUAL AMOUNT</h3>
          <BudgetTable2 data={budgetActualYear} />
        </div>
        <div className="frame-budget-block6-right">
          <h3>COST OF GOODS SOLD VS ACTUAL AMOUNT</h3>
          <BudgetTable2 data={budgetActualMonth} />
        </div>
      </div>

      <div className="frame-budget-block7">
        <div className="frame-budget-block7-left">
          <h3>EXPENSES VS ACTUAL AMOUNT</h3>
          <BudgetTable data={budgetExpensesActualYear} />
        </div>
        <div className="frame-budget-block7-right">
          <h3>EXPENSES VS ACTUAL AMOUNT</h3>
          <BudgetTable data={budgetExpensesActualMonth} />
        </div>
      </div>
    </div>
  );
};

export default Budget;
